import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElderlyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"elderly"}/>
}
